<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <side-bar :background-color="sidebarBackground">
      <template #links>
        <div class="sidebar-drawer-shell">
          <div class="sidebar-scroll-area">
            <v-navigation-drawer
              v-model="drawer"
              :mini-variant="mini"
              mobile-breakpoint="1024"
              permanent
            >
              <v-list :class="{ 'mini-list': mini }">
                <v-list-item
                  title="Home"
                  class="nav-link home-link mini-list-item"
                  @click="$router.push('/dashboard')"
                  link
                >
                  <v-list-item-icon v-if="mini" class="icon-mini">
                    <img
                      class="nav-icon"
                      :src="`/img/icons/gfb-logo-mini.svg`"
                    />
                    <span class="tooltipText">Home</span>
                  </v-list-item-icon>
                  <v-list-item-icon v-else class="icon-large">
                    <img
                      class="nav-icon"
                      :src="`/img/icons/gfb-logo-large.svg`"
                    />
                  </v-list-item-icon>

                  <v-list-item-content> </v-list-item-content>
                </v-list-item>
              </v-list>

              <v-list :class="{ 'mini-list': mini, 'nav-list': true }" dense>
                <v-list-item
                  :title="item.title"
                  v-for="item in sidebarItems"
                  :key="item.title"
                  class="nav-link"
                  @click="$router.push(item.to)"
                  link
                >
                  <v-list-item-icon>
                    <i :class="item.icon"></i>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                    <div
                      v-if="
                        ((item.title == 'Find employees' ||
                          item.title == 'Search Jobs') &&
                          hasJobBriefingNotification) ||
                        (item.title == 'Trade Partners' &&
                          hasProjectNotification) ||
                        (item.title == 'Find employees' &&
                          hasJobApplicationNotification)
                      "
                      style="
                        float: right;
                        position: relative;
                        top: -5px;
                        flex: unset;
                      "
                    >
                      <svg
                        width="13"
                        height="12"
                        viewBox="0 0 13 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="6.97656"
                          cy="6"
                          r="5"
                          fill="#FA0000"
                          stroke="white"
                          stroke-width="2"
                        />
                      </svg>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-list>

              <v-list class="logout-list" dense>
                <v-list-item
                  title="Logout"
                  class="nav-link"
                  @click="handleLogout"
                  link
                >
                  <v-list-item-icon>
                    <i class="ni ni-user-run"></i>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Logout</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-navigation-drawer>
          </div>
          <button
            @click.stop="mini = !mini"
            :class="['toggle-nav', { open: mini }]"
          >
            <PhCaretLeft size="20" weight="bold" />
          </button>
        </div>
      </template>
    </side-bar>

    <div class="main-content" :data="sidebarBackground">
      <AdminNavbar />
      <div @click="toggleSidebar">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <div class="admin-content-wrapper">
            <!-- your content here -->
            <router-view></router-view>
          </div>
        </fade-transition>
      </div>
    </div>
  </div>
</template>
<script>
import { FadeTransition } from "vue2-transitions"
import AdminNavbar from "./AdminNavbar.vue"
import { hasProjectNotification as hasProjectNotificationHelper } from "@/utils/notifications"
import { PhCaretLeft } from "@phosphor-icons/vue"

export default {
  components: {
    FadeTransition,
    AdminNavbar,
    PhCaretLeft,
  },
  data() {
    const sidebarItems = [
      {
        title: "Dashboard",
        to: "/admin/dashboard",
        icon: "fas fa-home",
      },
      {
        title: "Failed Emails",
        to: "/admin/failedemails",
        icon: "fas fa-envelope-open-text",
      },
      {
        title: "Companies",
        to: "/admin/companies",
        icon: "fas fa-handshake",
      },
      {
        title: "Job Seekers",
        to: "/admin/jobseekers",
        icon: "ni ni-single-02",
      },
      {
        title: "Onboard Companies",
        to: "/admin/onboard",
        icon: "fas fa-upload",
      },
      {
        title: "Interview Manager",
        to: "/admin/interview-manager",
        icon: "fas fa-clipboard-list",
      },
      {
        title: "Promotions",
        to: "/admin/promotions",
        icon: "fas fa-gift",
      },
    ]
    return {
      sidebarItems,
      sidebarBackground: "vue", //vue|blue|orange|green|red|primary,
      drawer: true,
      mini: true,
    }
  },
  computed: {
    hasProjectNotification() {
      const projects = this.$store.state.projects?.list || []
      const profilesRequested =
        this.$store.state.userProfile?.profilesRequested || []
      return hasProjectNotificationHelper(projects, profilesRequested)
    },
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false)
      }
    },
    async handleLogout() {
      try {
        await this.$router.replace("/logout")
      } catch (error) {
        console.error("Logout failed", error)
      }
    },
  },
}
</script>
<style lang="scss">
.wrapper {
  display: flex;
}

.v-navigation-drawer__content {
  display: flex;
  flex-direction: column;

  .logout-list {
    margin-top: auto;
  }
}
</style>
